const autoNgTemplateLoaderTemplate1 = require('./nodeTasksDatatable.html');

angular.module('portainer.docker').component('nodeTasksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
  },
});
